<template>
  <v-toolbar-items>
    <v-menu bottom left offset-y>
      <button class="user-menu-activator" slot="activator">
        <v-layout style="width: 70px" class="pr-1">
          <v-img max-height="32" contain :src="companyLogo" />
        </v-layout>

        <v-avatar size="32" class="user-avatar" color="primary darken-1">
          <img v-if="!!get(user, 'avatar.url')" :src="get(user, 'avatar.url')" :alt="user.name">
          <span v-else class="white--text">{{ acronym(user.name) }}</span>
        </v-avatar>
      </button>
      <v-card>
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-avatar color="primary darken-1">
              <img v-if="!!get(user, 'avatar.url')" :src="get(user, 'avatar.url')" :alt="user.name">
              <span v-else class="white--text">{{ acronym(user.name) }}</span>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ shortName(user.name) }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ get(user, 'role.name') }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <div class="user-menu-footer">
          <v-btn small flat class="text-capitalize user-menu-action" route to="/conta/perfil">Meus Dados</v-btn>
          <v-btn small flat class="text-capitalize user-menu-action" href="https://tawk.to/docgo" target="_blank">
            Suporte</v-btn>
          <v-btn small flat class="text-capitalize user-menu-action" @click="logout()">Sair</v-btn>
        </div>
      </v-card>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
import acronym from '@/utils/acronym';
import shortName from '@/utils/short-name';
import authService from '@/services/AuthenticationService';
import { get } from 'lodash';
import companyLogoUrl from '@/utils/company-logo-url';
import ConfigService from '@/services/system/ConfigService';


export default {
  name: 'user-menu',
  data() {
    return {
      shortName,
      companyLogo: '',
    };
  },
  mounted() {
    ConfigService.getConfigs()
      .then(({ data }) => {
        this.companyLogo = data.logo_url || '';
      });

    // Certifica-se de que os dados do usuário estão atualizados
    if (!this.get(this.user, 'avatar.url') && this.user.id) {
      this.$store.dispatch('getUser');
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    companyLogoUrl() {

      // return companyLogoUrl();
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('cleanFoldersData');
      authService.logout();
      this.$store.dispatch('logout');
      this.$router.push({ name: 'FormSignin' });
    },
    acronym(string) {
      return acronym(string);
    },
    get,
  },
};
</script>

<style lang="scss" scoped>
.user-menu-activator {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  min-height: 48px;
  overflow: hidden;
  padding: 0.25rem;
}

.user-menu-footer {
  display: flex;
  justify-content: space-around;
  background: #f5f5f5;
  padding: 0.35rem;
  border-top: 1px solid rgb(218, 218, 218);

  .user-menu-action {
    font-weight: normal;
    color: #666;
    border: 1px solid #c6c6c6;
  }
}

.user-avatar {
  margin: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/user-toolbar/UserMenu.vue